<div class="container-fluid">
  <span class="m-0 subheadText">{{ chartTitle | translate }}{{ chartSubtitle ? ' - ' + (chartSubtitle | translate) : '' }}</span>

  <div class="polarAreaChartContainer">
    <canvas #polarAreaChartCanvas></canvas>
  </div>

  @if (noDataOnChart) {
    <div class="my-3">
      <p>{{ 'STATISTICS.NO_CHART_DATA' | translate }}</p>
    </div>
  }
</div>